/* src/app/support/shell/file-upload-dialog/file-upload-dialog.component.css */
mat-dialog-content {
  margin-bottom: 16px;
}
mat-form-field {
  margin-top: 8px;
  margin-bottom: 8px;
}
mat-dialog-actions {
  padding-bottom: 8px;
}
input[type=file] {
  margin-top: 12px;
}
/*# sourceMappingURL=file-upload-dialog.component.css.map */
